/* rv-numbers: the count-up for "Sweat, by the numbers." (sections/rv-numbers.liquid; Cris, 2026-10-04: "add some
   sort of animation that counts the numbers up with a circle animation around the number").
   The server renders the final numbers and the full rings; this only enhances (BRIEF §4 #3: the old site's counters
   showed "0%" to crawlers and no-JS visitors). When it starts, only the stats still below the screen are set to 0;
   a stat on screen (or above it) keeps its final value, so nobody sees a 0 that isn't about to count. When 40% of a
   stat's ring is on screen above the strip the phones' sticky add-to-cart bar covers (--rv-sticky-reserve, 84px, in
   snippets/rv-tokens.liquid; read here, so the count never starts behind the bar), every number in its text counts
   up from 0 (both ends of "30–60%", the 4 in "About 4×"; the other characters stay) over 1.2s with an ease-out,
   while the arc draws with it. Once per stat; stats that come in together start 120ms apart. The counting digits
   are an aria-hidden copy laid over the real text, which stays in place (transparent, still read by screen
   readers), so nothing moves. Reduced motion, no IntersectionObserver or no JS: nothing changes. Printing finishes
   any count. The arc's dash is the only thing besides the digits that changes: one small SVG, repainted for 1.2s,
   then the loop stops. */
(() => {
  if (window.rvNumbers) return;
  window.rvNumbers = true;

  const D = document;
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const DUR = 1200;
  const GAP = 120;
  const RX = /\d[\d,]*(\.\d+)?/g;
  const seen = new WeakSet();
  const live = new Map(); /* stat → its count, from the reset to the end */
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  /* one number token at e (0..1) of its value, with the token's decimals and thousands commas */
  const num = (m, e) => {
    const d = (m.split('.')[1] || '').length;
    let [i, f] = (parseFloat(m.replace(/,/g, '')) * e).toFixed(d).split('.');
    if (m.indexOf(',') > -1) i = i.replace(/\B(?=(\d{3})+$)/g, ',');
    return f ? i + '.' + f : i;
  };

  /* the arc from a% to b% of the circle (clockwise from 12 o'clock), its round caps kept inside the ends (as Liquid) */
  const ring = (arc, a, b) => {
    const w = +arc.getAttribute('stroke-width');
    const c = 2 * Math.PI * +arc.getAttribute('r');
    const len = ((b - a) * c) / 100;
    arc.style.visibility = len > 0.5 ? '' : 'hidden';
    if (len >= c - 0.01) {
      arc.removeAttribute('stroke-dasharray');
      arc.removeAttribute('stroke-dashoffset');
      return;
    }
    arc.setAttribute('stroke-dasharray', Math.max(len - w, 0.01).toFixed(2) + ' ' + c.toFixed(2));
    arc.setAttribute('stroke-dashoffset', (-(a * c) / 100 - w / 2).toFixed(2));
  };

  const draw = (s, e) => {
    s.tick.textContent = e < 1 ? s.text.replace(RX, (m) => num(m, e)) : s.text;
    if (s.arc) ring(s.arc, s.a * e, s.b * e);
  };

  const done = (el) => {
    const s = live.get(el);
    if (!s) return;
    live.delete(el);
    draw(s, 1);
    s.tick.remove();
    s.big.classList.remove('is-count');
  };

  const play = (el) => {
    if (!live.has(el)) return;
    if (RM.matches) return done(el);
    let t0;
    const step = (now) => {
      const s = live.get(el);
      if (!s) return;
      if (t0 === undefined) t0 = now;
      const p = (now - t0) / DUR;
      if (p >= 1) return done(el);
      draw(s, ease(p));
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const io =
    'IntersectionObserver' in window &&
    new IntersectionObserver(
      (es) => {
        es.filter((e) => e.isIntersecting)
          .map((e) => (io.unobserve(e.target), e.target.closest('.rv-num__stat')))
          .sort((x, y) => (x.compareDocumentPosition(y) & 2 ? 1 : -1))
          .forEach((el, i) => setTimeout(() => play(el), i * GAP));
      },
      {
        threshold: 0.4,
        rootMargin:
          '0px 0px -' +
          (parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--rv-sticky-reserve')) || 0) +
          'px 0px',
      }
    );

  const init = (root) => {
    if (!io || RM.matches || !root.querySelectorAll) return;
    const vh = window.innerHeight;
    root.querySelectorAll('.rv-num[data-rv-count] .rv-num__stat').forEach((el) => {
      if (seen.has(el)) return;
      seen.add(el);
      const big = el.querySelector('.rv-num__big');
      const dial = el.querySelector('.rv-num__dial');
      /* on screen or above it: the final value stays */
      if (!big || !dial || el.getBoundingClientRect().top < vh) return;
      const arc = el.querySelector('.rv-num__arc');
      const tick = D.createElement('span');
      tick.className = 'rv-num__tick';
      tick.setAttribute('aria-hidden', 'true');
      const s = { big, tick, arc, text: big.textContent, a: arc ? +arc.dataset.a || 0 : 0, b: arc ? +arc.dataset.b || 0 : 0 };
      big.append(tick);
      big.classList.add('is-count');
      live.set(el, s);
      draw(s, 0);
      io.observe(dial);
    });
  };

  init(D);
  /* theme editor: a re-rendered section starts over (its stats on screen show their final values) */
  D.addEventListener('shopify:section:load', (e) => init(e.target));
  D.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.rv-num__stat').forEach((el) => {
      live.delete(el);
      const dial = el.querySelector('.rv-num__dial');
      if (io && dial) io.unobserve(dial);
    });
  });
  window.addEventListener('beforeprint', () => live.forEach((s, el) => done(el)));
})();
